<script setup lang="ts">
import { useAuthUser } from '@/helpers/globals';
import secLevel1Svg from '@/assets/images/security-level-1.svg';
import secLevel2Svg from '@/assets/images/security-level-2.svg';
import secLevel3Svg from '@/assets/images/security-level-3.svg';
import { ref } from 'vue';
import { appUrl } from '@/helpers/api';
import UserLoginModalCircus from '@/components/UserLoginModalCircus.vue';


const showLoginCircus = ref(false);

function increaseSecurity() {
    showLoginCircus.value = true;
}

</script>

<template>
    <h2 class="ktg-title-04">{{ $t('security') }}</h2>
    <p class="ktg-body mt-2rem" v-html="$t('security_info')"></p>
    <section class="security-data mt-3rem p-3rem">
        <h6 class="ktg-title-06">Die drei Sicherheitstufen</h6>
        <div class="card-list">
            <ktg-card appearance="white" id="security-level-1" :active="!useAuthUser()?.has_username_passkey">
                <ktg-card-visual slot="visual">
                    <img :src="secLevel1Svg" alt="level-1" />
                </ktg-card-visual>

                <ktg-pill v-if="!useAuthUser()?.has_username_passkey" slot="pill" appearance="success"
                    >Aktiviert</ktg-pill
                >

                <ktg-card-title slot="title">{{ $t('security_level') }} 1</ktg-card-title>

                <ktg-card-text slot="text">{{ $t('security_level_1_info') }}</ktg-card-text>
            </ktg-card>
            <ktg-card appearance="white" id="security-level-2" :active="useAuthUser()?.has_username_passkey">
                <ktg-card-visual slot="visual">
                    <img :src="secLevel2Svg" alt="level-2" />
                </ktg-card-visual>

                <ktg-pill v-if="useAuthUser()?.has_username_passkey" slot="pill" appearance="success"
                    >Aktiviert</ktg-pill
                >

                <ktg-card-title slot="title">{{ $t('security_level') }} 2</ktg-card-title>

                <ktg-card-text slot="text">{{ $t('security_level_2_info') }}</ktg-card-text>
            </ktg-card>
            <ktg-card appearance="white" id="security-level-3" class="disabled">
                <ktg-card-visual slot="visual">
                    <img :src="secLevel3Svg" alt="level-3" />
                </ktg-card-visual>

                <ktg-card-title slot="title">{{ $t('security_level') }} 3</ktg-card-title>

                <ktg-card-text slot="text">{{ $t('security_level_3_info') }}</ktg-card-text>
            </ktg-card>
        </div>
        <div class="flex justify-content-end" v-if="!useAuthUser()?.has_username_passkey">
            <ktg-link id="security-data-change-security-level" href="#" @click="increaseSecurity">{{
                $t('security_increase_link_text')
            }}</ktg-link>
        </div>
    </section>
    <UserLoginModalCircus
            :user="useAuthUser()"
            v-model="showLoginCircus"
            :redirectUrl="appUrl('/useraccount/security')"
            :initialState="5"
        />
</template>

<style scoped lang="scss">
.security-data {
    background-color: var(--ktg-color-neutral-01);
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .card-list {
        display: grid;
        width: 100%;
        row-gap: 1rem;
        grid-template-columns: repeat(1, 1fr);
        column-gap: 1rem;

        @media only screen and (min-width: 1308px) {
            grid-template-columns: repeat(3, 1fr);
            column-gap: 1rem;
        }

        .disabled {
            filter: grayscale(1);
            opacity: 0.5;
        }
    }
}
</style>
